module.exports = __webpack_public_path__ + "img/logo-sunuassur.2e11effd.jpg";